<template>
  <div class="page-header-container">
    <div class="page-header">
      <h1>{{title}}</h1>
      <div class="logged-box">
        <p class="logged-msg">LOGGED IN AS</p>
        <p class="logged-user">{{userName}}</p>
        <p class="logged-button" @click="logout()">LOG OUT</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',

  props: {
    title: {
      default: ''
    },
    icon: {
      default: ''
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('users/logout');
    }
  },

  computed: {
    userName() {
      return this.$store.state.users.user.email;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.page-header-container {
  .page-header {
    display: flex;
    background: $sec0;
    padding: 0 $spacing-base;
    height: 100px;
    box-sizing: border-box;
    position: relative;
    z-index: 9;
    h1 {
      margin: 0;
      padding: 0;
      line-height: 100px;
      color: white;
      font-size: 2.5em;
      float: left;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-transform: uppercase;
      margin-right: $spacing-base;
    }
    .icon {
      color: white;
      background-image: url(~@/assets/nav_icons/nav_shrink.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      width: 15px;
      margin-right: $spacing-base;
    }
    .logged-box {
      text-align: right;
      margin: auto;
      font-size: $font-size-base;
      text-transform: uppercase;
      p {
        margin: 0;
        margin-top: 2px;
      }
      .logged-msg {
        color: $sec5;
      }
      .logged-user {
        color: white;
        font-weight: bold;
      }
      .logged-button {
        color: $blue;
        cursor: pointer;
        user-select: none;
      }
    }
  }
}
</style>